import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    ContactMaster,
    SortingOptions,
    ContactTag,
    ContactDescription,
} from "../types";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

interface IContactsState {
    list: ContactMaster[];
    sortingOptions: SortingOptions;
    allTagsList: ContactTag[];
    allTagsObject: { [tag_name: string]: ContactTag };
    allFacts: ContactDescription[];
}

const initialState: IContactsState = {
    list: [],
    sortingOptions: {
        recent: 1,
        alphabetical: 0,
        keyword: "",
        contactIds: {},
    },
    allTagsList: [],
    allTagsObject: {},
    allFacts: [],
};

export const contactsSlice = createSlice({
    name: "contacts",
    initialState,
    reducers: {
        setContacts: (state, action: PayloadAction<ContactMaster[]>) => {
            return {
                ...state,
                list: action.payload,
            };
        },
        setSortingOptions: (
            state,
            action: PayloadAction<
                | SortingOptions
                | ((sortingOptions: SortingOptions) => SortingOptions)
            >
        ) => {
            if (typeof action.payload === "function") {
                return {
                    ...state,
                    sortingOptions: action.payload(state.sortingOptions),
                };
            }
            return {
                ...state,
                sortingOptions: action.payload,
            };
        },
        setAllTagsList: (state, action: PayloadAction<ContactTag[]>) => {
            return {
                ...state,
                allTagsList: action.payload,
                allTagsObject: action.payload.reduce(
                    (
                        acc: { [tag_name: string]: ContactTag },
                        val: ContactTag
                    ) => ({ ...acc, [val.description]: val }),
                    {}
                ),
            };
        },
        setAllFacts: (state, action: PayloadAction<ContactDescription[]>) => {
            return {
                ...state,
                allFacts: action.payload,
            };
        },
    },
});

export const { setContacts, setSortingOptions, setAllTagsList, setAllFacts } =
    contactsSlice.actions;
const persistConfig = {
    key: "session",
    storage,
};
export default contactsSlice.reducer;
// export default persistReducer(persistConfig, contactsSlice.reducer);
